import { NextUpMobileOnly } from 'NextUp';

export const CurrentlyStudying = () => (
    <div className="h-full px-4 pt-9">
        <NextUpMobileOnly />
        <div className="mt-5 flex items-center justify-center">Currently Studying</div>
    </div>
);
